import { JSONSchema7 } from 'json-schema';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import Translator from '../../Shared/translator';

const upgradeControl = (
  controlSchema: JSONSchema7,
  latestSchema: JSONSchema7,
  schemaTranslator: Translator
) => {
  const controlProperties = controlSchema.properties as JSONSchema7Properties;
  const versionSchema = controlProperties['version'] as JSONSchema7;
  const currVer = versionSchema ? (versionSchema.default as number) : 0;

  const latestSchemaProperties =
    latestSchema.properties as JSONSchema7Properties;
  const latestVersionSchema = latestSchemaProperties['version'] as JSONSchema7;
  const latestVer = latestVersionSchema.default as number;

  let updatedSchema: JSONSchema7 = { ...controlSchema };
  for (let v = currVer; v < latestVer; v++) {
    const translator = schemaTranslator[`v${v}_v${v + 1}`];
    if (translator) {
      updatedSchema = translator(controlSchema);
    }
  }

  return updatedSchema;
};

export default upgradeControl;
